import styled from 'styled-components'
import {
  btnBorderRadius,
  btnDefaultBg,
  btnDefaultColor,
  btnPrimaryBg,
  btnPrimaryColor,
  btnSecondaryBg,
  btnSecondaryColor,
} from 'utils/style-utils'

export const BadgesContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0;
`

export const BadgesBox = styled.div`
  position: absolute;
  z-index: 1;
  top: -0.5rem;
  right: -0.25rem;

  display: flex;
  flex-wrap: wrap;
  justify-content: right;
  gap: 0.5rem;
  user-select: none;
`

const Badge = styled.div`
  background: ${btnDefaultBg};
  color: ${btnDefaultColor};
  font-size: 0.875rem;
  font-weight: 700;
  padding: 0.125rem 0.5rem;
  border-radius: ${btnBorderRadius};
  line-height: 1em;
`

export const PrimaryBadge = styled(Badge)`
  background: ${btnPrimaryBg};
  color: ${btnPrimaryColor};
  box-shadow:
    ${btnPrimaryBg} 0 0 0.125rem,
    ${btnPrimaryBg} 0 0 1rem;
`

export const SecondaryBadge = styled(Badge)`
  background: ${btnSecondaryBg};
  color: ${btnSecondaryColor};
  box-shadow:
    ${btnSecondaryBg} 0 0 0.125rem,
    ${btnSecondaryBg} 0 0 1rem;
`
